/** Версия приложения вида `1.2.3` (только числа, 3 части — как в сторах). */
const VERSION_RE = /^(\d+)\.(\d+)\.(\d+)$/;

export function isValidVersion(value: string): boolean {
  return VERSION_RE.test(value.trim());
}

/** Сравнение версий: <0 если a<b, 0 если равны, >0 если a>b. Невалидные → null. */
export function compareVersions(a: string, b: string): number | null {
  const ma = VERSION_RE.exec(a.trim());
  const mb = VERSION_RE.exec(b.trim());
  if (!ma || !mb) return null;
  for (let i = 1; i <= 3; i++) {
    const diff = Number(ma[i]) - Number(mb[i]);
    if (diff !== 0) return diff;
  }
  return 0;
}
